import {
	AfterViewInit,
	Component,
	computed,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import {
	faLink,
	faSquare,
	faCheckSquare,
	faTrash,
	faQuestionCircle,
	faLock,
	faXmark,
	faTimes,
	faAngleDown,
	faAngleUp,
	faAngleRight,
} from '@fortawesome/free-solid-svg-icons';
import { requestInterface } from 'src/app/util/interfaces/request';
import { RequestOpeningService } from './service/request-opening.service';
import { TokenizationService } from 'src/app/services/tokenization/tokenization.service';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { templateReworkInterface } from 'src/app/util/interfaces/templateRework';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ALL_SERVICE_TYPES, requestClassificationInterface, SERVICE_TYPES_ENUM } from 'src/app/util/interfaces/requestClassification';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { FilesService } from 'src/app/services/files/files.service';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { RequestPageService } from 'src/app/page/request/request-page/service/request-page.service';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { ShkDate } from 'shk-date';
import { mimeTypeInterface } from 'src/app/util/interfaces/mimeTypeInterface';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CmdbInfoPageService } from 'src/app/page/cmdb/cmdb-info-page/service/cmdb-info-page.service';
import { MspTableComponent, mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { EncodingMSPService } from 'src/app/services/encoding/encoding-msp.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import {
	taskManagementInterface,
	TaskManagementService,
} from 'src/app/page/register-page/register-forms/request/task-management/service/task-management.service';
import { classificationInterface } from 'src/app/util/interfaces/classification';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { Subscription } from 'rxjs';
import { SearchInformationService } from '../search-information/service/search-information.service';
import { LocationOption } from 'src/app/util/interfaces/locationInterface';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { SessionStatus } from 'src/app/services/profile/sessionStatus.enum';
import { CommonModule } from '@angular/common';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { MysupportEvaluationModule } from '../mysupport-evaluation/mysupport-evaluation.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { CmdbSearchGadgetComponent } from '../cmdb-search-gadget/cmdb-search-gadget.component';
import { RequestCustomfieldModule } from '../request-customfield/request-customfield.module';
import { RequestClassificationReverseRmkComponent } from '../request-classification-reverse-rmk/request-classification-reverse-rmk.component';
import { FormsModule } from '@angular/forms';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { CheckboxModule } from 'src/app/page_component_item/checkbox/checkbox.module';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { requestOpeningOptions } from './service/request-opening.interface';
import { MspTableRmkComponent } from 'src/app/page_component_item/msp-table-rmk/msp-table-rmk.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { mspTableSearch, mspTableSort } from 'src/app/page_component_item/msp-table-rmk/components/msp-table.interfaces';
import { InconsistencyInterface } from 'src/app/util/interfaces/myAssetInterface';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		SvgGearsModule,
		MysupportEvaluationModule,
		FontAwesomeModule,
		MspTableRmkComponent,
		RouterModule,
		DotBounceLoadingEffectModule,
		CmdbSearchGadgetComponent,
		RequestCustomfieldModule,
		RequestClassificationReverseRmkComponent,
		GenericFormGenModule,
		InputWithAutocompleteModule,
		CheckboxModule,
		DotBounceLoadingEffectModule,
		MspTableRmkComponent,
	],
	selector: 'pcp-request-opening',
	templateUrl: './request-opening.component.html',
	styleUrls: ['./request-opening.component.scss'],
})
export class RequestOpeningComponent implements OnInit, OnChanges {
	icons = {
		faLink: faLink,
		faSquare: faSquare,
		faCheckSquare: faCheckSquare,
		faTrash: faTrash,
		faQuestionCircle: faQuestionCircle,
		faXmark: faXmark,
		faLock: faLock,
		faTimes: faTimes,
		faAngleDown: faAngleDown,
		faAngleUp: faAngleUp,
		faAngleRight: faAngleRight,
	};

	labels: LabelsInterface;

	collapseContainer = {
		enduser: false,
		bondCi: false,
	};

	@Output() newRequestCreated = new EventEmitter();

	constructor(
		private RequestOpeningService: RequestOpeningService,
		private TokenizationService: TokenizationService,
		private NotificationService: NotificationService,
		private FilesService: FilesService,
		private RequestPageService: RequestPageService,
		private ActivatedRoute: ActivatedRoute,
		private CmdbInfoPageService: CmdbInfoPageService,
		private labelsService: LabelsService,
		public PermissionService: PermissionService,
		public ProfileService: ProfileService,
		public EncodingMSP: EncodingMSPService,
		public taskManagementService: TaskManagementService
	) {
		this.labels = computed(() => {
			return this.labelsService.labels();
		})();
	}

	classificationOptions = {
		isEditingClassification: true,
		alertField: [],
		lockField: ['severity'],
		hideServiceType: [],
		selectedCustomer: this.ProfileService.userData().idCustomer,
		idCmdb: '',
		isReverseClassification: true,
	};

	@Input() options: requestOpeningOptions = {
		disable: [],
		hide: [],
		hide_service_type: [],
		initial_enduser: null,
		initial_summary: '',
		initial_description: '',

		id_enduser: '',
		enduser: '',
		id_customer: '',

		initial_related_request_id: '',
		related_cis: [],
	};

	isAnalystView = this.ProfileService.userData().sessionStatus == SessionStatus.ANALYST;
	isEnduserView = this.ProfileService.userData().sessionStatus == SessionStatus.ENDUSER;

	isLoadingAvailableConfidentialUsers = true;
	isLoadingAvailableTemplates = false;
	isLoadingRequestTemplate = false;
	isCustomfieldLoading = false;
	isLoadingIncidentDiscovery = false;
	isLoadingEnduserData = false;
	isLoadingAvailableConfidentialAnalysts = false;

	hasTemplate = true;
	isCustomfieldFulfilled = true;
	verifyFields = false;
	isClassificationGoingOn = false;
	isClassificationFulfilled = false;
	isOpeningRequest = false;
	isUploadingCustomfields = [];
	isOpenModalEvaluationMSP = false;
	forceOpenRequestWithCi = false;
	relatedCisOptionsTable: mspTableHeaderI[];
	relatedCisOptionsSort: mspTableSort = { sortBy: 'id', sortOrder: 'desc', sortDown: true };
	relatedCisOptionsSearch: mspTableSearch = {};
	@Input() relatedCisOptions: ciInterface2[] = [];
	relatedCisOptionsData = () => {
		let filteredOptions = this.relatedCisOptions.filter((option) => {
			if (Object.keys(this.relatedCisOptionsSearch).length === 0) return option;
			for (const key of Object.keys(this.relatedCisOptionsSearch)) {
				if (option[key].toString().toLowerCase().includes(this.relatedCisOptionsSearch[key][0].toString().toLowerCase())) {
					return option;
				}
			}
		});
		filteredOptions = filteredOptions.sort((a, b) => {
			const aValue = String(a[this.relatedCisOptionsSort.sortBy]).localeCompare(
				String(b[this.relatedCisOptionsSort.sortBy]),
				undefined,
				{ numeric: true, sensitivity: 'base' }
			);
			return this.relatedCisOptionsSort.sortDown ? aValue : -aValue;
		});
		return filteredOptions;
	};

	relatedIncident: requestInterface[] = [];
	selectedRelatedIncident: requestInterface;
	isRelatedIncidentScreenOpen = false;
	isAlertRelatedInciedent = false;

	reverseClassification = true;

	@Input()
	requestTemplateId = '';
	initOnTemplate = true;
	requestTemplate: templateReworkInterface = {
		id: '',
		summary: '',
		status: '',
		description: '',
		informative: '',
		fields: [],
	};

	customConfidentialForm = new genericFormI('selectable-list');
	customConfidentialFormRMK = new genericFormI('selectable-list');
	availableTemplateIAC: iacOptionInterface[] = [];

	availableConfidentialUsers: any[] = [];
	availableConfidentialUsersIAC: iacOptionInterface[] = [];

	@Input() newRequest: requestInterface;
	@Input() idRelatedInconsistency: InconsistencyInterface['id'];

	enduserData: enduserInterface;

	logFileArray: mspFileInterface[] = [];
	customfields: genericFormInterface[] = [];
	fileCustomfields: genericFormInterface[] = [];
	oldSummary = '';

	allowedCiTypes: number[] = [];
	selectedBondCi: ciInterface2;
	bondedCiArr: string[] = [];

	@Input()
	resetDetailment = false;

	allowedMimeTypes: mimeTypeInterface[] = [];
	allowedMimeTypeStr = '';
	allowedMimeTypeTip = '';

	requestClassification: classificationInterface[] = [];
	serviceType = '';
	SERVICE_TYPES_ENUM = SERVICE_TYPES_ENUM;
	templateReq: Subscription;
	enduserDataReq: Subscription;

	affectedLocations: LocationOption[] = [];

	ngOnInit(): void {
		this.setEmptyNewRequest(true);

		this.relatedCisOptionsTable = [
			{ name: 'id', value: this.labels['lbl_geral_id'], colType: 'text' },
			{ name: 'identification', value: this.labels['lbl_geral_identificacao'], colType: 'text' },
			{ name: 'type', value: this.labels['lbl_geral_tipo'], colType: 'text' },
		];

		if (this.options.related_cis?.length > 0) {
			this.CmdbInfoPageService.getCiMinData(this.options.related_cis).subscribe((ciRes) => {
				this.newRequest.relatedCis = ciRes;
			});
		} else {
			this.ActivatedRoute.queryParams.subscribe((parameters) => {
				if (parameters.idCmdb && parameters.idCmdb != '') {
					this.classificationOptions.idCmdb = parameters.idCmdb;
					this.forceOpenRequestWithCi = true;
					this.isClassificationGoingOn = true;
					this.CmdbInfoPageService.getCiMinData([parameters.idCmdb]).subscribe((ciRes) => {
						this.newRequest.relatedCis = ciRes;
					});
				}
			});
		}

		if (this.options.id_customer == '') this.options.id_customer = this.ProfileService.userData().idCustomer;

		this.customConfidentialForm.name = 'confidentialUsers';
		this.customConfidentialForm.label = 'lbl_quem_podera_visualizar';
		this.RequestOpeningService.getAvailableConfidentialUsers(this.options.id_customer).subscribe({
			next: (availableUsers) => {
				for (const user of availableUsers) {
					const userGeneric: genericFormI = new genericFormI('item');
					userGeneric.id = user.id;
					userGeneric.name = user.fullName;
					userGeneric.label = user.fullName;
					userGeneric.values[0] = user.id;
					userGeneric.commonGroup = user.email;
					this.customConfidentialForm.items.push(userGeneric);
				}

				this.availableConfidentialUsers = [];
				this.availableConfidentialUsersIAC = [];
				this.availableConfidentialUsers = availableUsers;
				for (const user of this.availableConfidentialUsers) {
					const usersIAC: iacOptionInterface = {
						name: user.fullName,
						value: user.id,
						commonGroup: user.email,
					};
					this.availableConfidentialUsersIAC.push(usersIAC);
				}
			},
			complete: () => {
				this.isLoadingAvailableConfidentialUsers = false;
			},
		});

		/*if (this.isAnalystView) {*/
		this.isLoadingAvailableTemplates = false;
		this.isClassificationGoingOn = true;
		if (this.requestTemplateId == '') {
			this.hasTemplate = false;
			this.initOnTemplate = false;
			this.loadAvailableTemplates();
		} else {
			this.isClassificationFulfilled = true;
		}
		/*} else {
			this.hasTemplate = true;
			this.forceOpenRequestWithCi = false;
			this.initOnTemplate = false;
		}*/

		if (this.options) {
			if (this.options.hide_service_type && this.options.hide_service_type.length > 0) {
				this.classificationOptions.hideServiceType = this.options.hide_service_type;
			}
			if (this.options.initial_related_request_id && this.options.initial_related_request_id != '') {
				this.newRequest.parent_request.id = this.options.initial_related_request_id;
				this.requestTemplate.summary = `${this.labels.lbl_geral_chamado_relacionado ? this.labels.lbl_geral_chamado_relacionado + ' - ' : ''} ${this.options.initial_related_request_id} `;
			}
			if (this.options.initial_summary && this.options.initial_summary != '') {
				this.requestTemplate.summary = this.options.initial_summary;
			}
			if (this.options.initial_description && this.options.initial_description != '') {
				this.requestTemplate.description = this.options.initial_description;
			}
			if (this.options.initial_enduser && this.options.initial_enduser != '') {
				this.newRequest.enduser = this.options.initial_enduser;
			}
			if (this.options.id_enduser && this.options.id_enduser != '') {
				this.newRequest.id_enduser = this.options.id_enduser;
				this.searchEnduserData();
			}
			if (this.options.hide && this.options.hide.length > 0 && this.options.hide.includes('classifyButton')) {
				this.isClassificationGoingOn = true;
			}
		}

		this.FilesService.getAllowedMimeType().subscribe((allowedMimeTypes) => {
			this.allowedMimeTypes = allowedMimeTypes;
			this.allowedMimeTypeTip += `${this.labels.lbl_tipos_arquivo_permitidos}: `;
			for (const [index, mt] of this.allowedMimeTypes.entries()) {
				this.allowedMimeTypeStr += `${mt.mime_type},`;
				this.allowedMimeTypeTip += `${mt.extension}${index == this.allowedMimeTypes.length - 1 ? '' : ', '}`;
			}
			this.allowedMimeTypeTip += ` ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`;
		});

		this.RequestOpeningService.getAvailableOptions({ idCustomer: this.options.id_customer }).subscribe({
			next: (data) => {
				this.affectedLocations = data.affectedLocations;
			},
			error: (error) => {
				console.error('Erro ao carregar opções:', error);
			},
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.resetDetailment && changes.resetDetailment.currentValue === true) {
			this.setEmptyTemplate();
			this.setEmptyNewRequest();
			setTimeout(() => {
				this.resetDetailment = false;
			}, 1);
		} else if (changes && changes.requestTemplateId && changes.requestTemplateId.currentValue != '') {
			this.setTemplate();
		}
	}

	setTemplate(idTemplate?: string): void {
		if (idTemplate) this.requestTemplateId = idTemplate;
		this.resetRequest();
		this.isLoadingRequestTemplate = true;
		this.RequestOpeningService.getTemplate(this.requestTemplateId).subscribe((requestTemplateRes) => {
			this.customfields =
				requestTemplateRes.fields.length > 0
					? requestTemplateRes.fields.map((field) => ({
							id: field.id,
							label: field.field_name,
							name: field.field_name,
							inputType: field.field_type,
						}))
					: [];
			this.requestTemplate = requestTemplateRes;
			this.newRequest.description = requestTemplateRes.description;
			this.newRequest.summary = requestTemplateRes.summary;
			this.newRequest.allowedCiTypes = requestTemplateRes.allowedCiTypes;
			this.newRequest.mandatoryCiBinding = requestTemplateRes.mandatoryCiBinding;
			this.newRequest.confidential = requestTemplateRes.confidential_request ? '1' : '0';

			// Popula os campos de classificação do newRequest com os dados do template
			if (requestTemplateRes.id_service_type) this.newRequest.service_type = requestTemplateRes.id_service_type.toString();
			if (requestTemplateRes.id_scope) this.newRequest.id_scope = requestTemplateRes.id_scope.toString();
			if (requestTemplateRes.id_category) this.newRequest.id_category = requestTemplateRes.id_category.toString();
			if (requestTemplateRes.id_topic) this.newRequest.id_topic = requestTemplateRes.id_topic.toString();
			if (requestTemplateRes.id_solution_area) this.newRequest.id_solution_area = requestTemplateRes.id_solution_area.toString();

			this.isLoadingRequestTemplate = false;
			this.isClassificationFulfilled = true;
			this.hasTemplate = true;

			// Carrega usuários confidenciais do grupo após popular os dados de classificação
			this.loadConfidentialGroupUsers();
		});
	}

	setClassification(classification: string): void {
		const requestClassification: requestClassificationInterface = JSON.parse(classification);
		this.requestClassification = JSON.parse(classification);
		const forcedCi = this.newRequest.relatedCis[0];
		this.customfields = [];
		this.fileCustomfields = [];

		let allNamesExist = true;
		const values: { [key: string]: string } = {}; // Objeto para armazenar os valores

		// Lista de chaves que você deseja verificar
		const keysToCheck = ['serviceType', 'scope', 'category', 'topic', 'solutionArea'];

		for (const key of keysToCheck) {
			if (this.requestClassification[key] && this.requestClassification[key][0] && this.requestClassification[key][0].name) {
				// Armazena o valor de `name` na variável `values`
				values[key] = this.requestClassification[key][0].name;
			} else {
				allNamesExist = false;
			}
		}

		this.newRequest.relatedCis = this.forceOpenRequestWithCi ? [forcedCi] : [];

		this.requestTemplate.id_topic = undefined;
		this.requestTemplate.id_category = undefined;
		this.requestTemplate.id_solution_area = undefined;

		this.newRequest.service_type = requestClassification.serviceType[0] ? requestClassification.serviceType[0].id : '';
		this.newRequest.id_scope = requestClassification.scope[0] ? requestClassification.scope[0].id : '';
		this.newRequest.id_category = requestClassification.category[0] ? requestClassification.category[0].id : '';
		this.newRequest.id_topic = requestClassification.topic[0] ? requestClassification.topic[0].id : '';
		this.newRequest.id_solution_area = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].id : '';

		this.newRequest.impact = requestClassification.severity[0] ? requestClassification.impact[0].impact : '';
		this.newRequest.urgency = requestClassification.severity[0] ? requestClassification.urgency[0].urgency : '';
		this.newRequest.severity = requestClassification.severity[0] ? requestClassification.severity[0].severity : '';

		this.newRequest.allowedCiTypes = requestClassification.scope[0]?.allowedCiTypes
			? requestClassification.scope[0].allowedCiTypes
			: [];
		this.newRequest.mandatoryCiBinding = requestClassification.scope[0]?.mandatoryCiBinding
			? requestClassification.scope[0].mandatoryCiBinding
			: false;

		if (
			(!this.reverseClassification && this.newRequest.id_solution_area != '') ||
			(this.reverseClassification && this.newRequest.id_topic)
		) {
			this.isClassificationGoingOn = true;
			this.requestTemplate.id_topic = Number.parseInt(this.newRequest.id_topic);
			this.requestTemplate.id_category = Number.parseInt(this.newRequest.id_category);
			this.requestTemplate.id_solution_area = Number.parseInt(this.newRequest.id_solution_area);

			this.loadConfidentialGroupUsers();

			if (this.newRequest.service_type?.toString() == '2' && this.newRequest.relatedCis?.length > 0) {
				const id_cmdb = this.newRequest.relatedCis.map((ci) => {
					return ci.id;
				});
				this.isLoadingIncidentDiscovery = true;
				this.RequestOpeningService.getIncidentDiscovery(
					this.newRequest.id_scope,
					this.newRequest.id_category,
					this.newRequest.id_topic,
					this.newRequest.id_solution_area,
					id_cmdb
				).subscribe({
					next: (relatedIncidentRes) => {
						this.relatedIncident = relatedIncidentRes;
						if (this.selectedRelatedIncident == undefined) {
							if (this.relatedIncident.length > 0) this.isRelatedIncidentScreenOpen = true;
						} else {
							this.isAlertRelatedInciedent = true;
						}
					},
					error: () => {},
					complete: () => {
						this.isLoadingIncidentDiscovery = false;
					},
				});
			}
		}

		if (this.newRequest.id_solution_area && this.newRequest.id_category) {
			this.RequestOpeningService.getCustomfieldSearch(this.newRequest.id_category, this.newRequest.id_solution_area).subscribe(
				(field) => {
					this.customfields =
						field && typeof field === 'object' && Object.keys(field).length > 0
							? field.map((field) => ({
									id: field.id,
									label: field.field_name,
									name: field.field_name,
									inputType: field.field_type,
								}))
							: [];
				},
				(error) => {
					console.error('Erro ao buscar campos personalizados', error);
				}
			);
		}
	}

	setSelectedCi(ci: ciInterface2): void {
		if (this.bondedCiArr.includes(ci.id)) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_vinculou_ci_existente);
			return;
		}

		this.bondedCiArr.push(ci.id);
		this.newRequest.relatedCis.push(ci);

		if (
			(this.newRequest.service_type == '2' && !this.reverseClassification && this.newRequest.id_solution_area != '') ||
			(this.reverseClassification && this.newRequest.id_topic)
		) {
			const id_cmdb = this.newRequest.relatedCis.map((ci) => {
				return ci.id;
			});
			this.isLoadingIncidentDiscovery = true;
			this.RequestOpeningService.getIncidentDiscovery(
				this.newRequest.id_scope,
				this.newRequest.id_category,
				this.newRequest.id_topic,
				this.newRequest.id_solution_area,
				id_cmdb
			)
				.subscribe({
					next: (relatedIncidentRes) => {
						this.relatedIncident = relatedIncidentRes;
						if (this.selectedRelatedIncident == undefined) {
							if (this.relatedIncident.length > 0) this.isRelatedIncidentScreenOpen = true;
						} else {
							this.isAlertRelatedInciedent = true;
						}
					},
				})
				.add(() => {
					this.isLoadingIncidentDiscovery = false;
				});
		}
	}

	unbondCi(ciIndex: number): void {
		this.bondedCiArr.splice(this.bondedCiArr.indexOf(this.newRequest.relatedCis[ciIndex].id), 1);
		if (this.newRequest.relatedCis[ciIndex].id == this.classificationOptions.idCmdb) return;
		this.newRequest.relatedCis.splice(ciIndex, 1);
	}

	handleFileLog(index?: number): void {
		const requestOpeningFileElement = (<HTMLInputElement>document.querySelector('#requestOpeningFileEl')).files;
		if (index == undefined) {
			Array.prototype.forEach.call(requestOpeningFileElement, (file: File) => {
				if (!this.FilesService.nameAllowed(file)) {
					return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nomes_arquivos_caracteres_especiais);
				}

				this.FilesService.MSPFileFromFile(file).then((mspFile) => {
					for (let index_ = 0; index_ < this.logFileArray.length; index_++) {
						const logFile = this.logFileArray[index_];
						if (logFile.content != mspFile.content) continue;

						this.NotificationService.setNotificationMessage(this.labels.lbl_arquivo_adicionado);
						return;
					}
					if (Math.floor(mspFile.size / 1_000_000) > this.allowedMimeTypes[0].max_file_size) {
						this.NotificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_limite_tamanho_excedido} ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`
						);
					} else if (mspFile.mimeType == '' || !this.allowedMimeTypeStr.includes(mspFile.mimeType)) {
						this.NotificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_formato_invalido_ou_corrompido}`
						);
					} else {
						this.logFileArray.push(mspFile);
					}
				});
			});
			(<HTMLInputElement>document.querySelector('#requestOpeningFileEl')).value = null;
		} else {
			this.logFileArray.splice(index, 1);
		}
	}

	resetRequest(cleanTemplate?: boolean): void {
		if (!this.newRequest) {
			this.setEmptyNewRequest(true);
		}
		if (cleanTemplate) {
			this.requestTemplate.summary = '';
			this.requestTemplate.description = '';
			this.requestTemplateId = '';
			this.requestTemplate.confidential_request = undefined;

			this.hasTemplate = this.isAnalystView ? false : true;
		}
		if (this.requestTemplateId != '') {
			this.newRequest.service_type = '';
			this.newRequest.scope = '';
			this.newRequest.category = '';
			this.newRequest.topic = '';
			this.newRequest.id_solution_area = '';
			this.newRequest.allowedCiTypes = [];
			this.newRequest.mandatoryCiBinding = false;
			this.newRequest.relatedCis = [];
			this.requestTemplate.id_topic = undefined;
			this.requestTemplate.id_category = undefined;
			this.requestTemplate.id_solution_area = undefined;
			this.isClassificationGoingOn = false;
			this.isClassificationFulfilled = false;
			this.customfields = [];
			this.fileCustomfields = [];
		}
	}

	isDescriptionRequiredAndMissing(): boolean {
		return this.requestTemplate.description_required && (!this.newRequest.description || this.newRequest.description.trim() === '');
	}

	submitRequest(): void {
		if (this.isLoadingRequestTemplate || this.isCustomfieldLoading || this.isOpeningRequest) return;

		const customfieldBody = { requestFields: [] };

		if (this.hasTemplate && this.requestTemplate.summary && this.requestTemplate.summary.trim() === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_sumario_nao_pode_ser_vazio);
			return;
		}

		if (this.newRequest.id_enduser && this.newRequest.id_enduser === '0') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_usuario_do_chamado);
			return;
		}

		if (this.newRequest.mandatoryCiBinding == true && this.newRequest.relatedCis.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_vincular_pelo_menos_um_ci);
			return;
		}
		if (Number(this.newRequest.service_type) === 3 && this.newRequest.riskType === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_erro_request_fields);
		} else {
			this.newRequest.riskType = '';
		}

		let relatedCisIds = '';
		for (const ci of this.newRequest.relatedCis) {
			relatedCisIds += ci.id + ',';
		}
		relatedCisIds = relatedCisIds.slice(0, -1);

		if (this.isAnalystView && !this.isClassificationFulfilled) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos_classificar);
			return;
		}

		if (this.isDescriptionRequiredAndMissing()) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_descricao_justificativa_obrigatoria);
		}

		if (this.customfields && this.customfields.length > 0) {
			//Tem customfield
			if (!this.isCustomfieldFulfilled) {
				this.verifyFields = true;
				setTimeout(() => {
					this.verifyFields = false;
				}, 100);
				this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos_customizados);
				return;
			}

			for (let index = 0; index < this.customfields.length; index++) {
				const customfield = this.customfields[index];
				const isJsonDynamic = customfield.rawInputType === 'json_dynamic';

				// Verificar se o valor excede 255 caracteres (exceto json_dynamic que guarda JSON)
				if (!isJsonDynamic && customfield.values[0] && customfield.values[0].length > 255) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_max_caracteres_campo_customizado);
					return; // Parar a execução de toda a função
				}

				if (customfield.inputType == 'attachment' || customfield.rawInputType == 'attachment') {
					this.fileCustomfields.push(customfield);
				} else if (customfield.inputType == 'multi-select' || customfield.inputType == 'checkbox') {
					const newCustomfieldBodyItem = {
						fieldID: customfield.id,
						fieldValue: customfield.rawValues.join('§'),
						fieldType: customfield.inputType,
					};
					customfieldBody.requestFields.push(newCustomfieldBodyItem);
				} else {
					const newCustomfieldBodyItem: any = {
						fieldID: customfield.id,
						// json_dynamic: rawValues[0] é o JSON do objeto; values[0] é apenas o autoId
						fieldValue: isJsonDynamic ? (customfield.rawValues?.[0] ?? '') : customfield.values[0],
						fieldType: customfield.rawInputType ?? customfield.inputType,
					};
					if (isJsonDynamic) {
						newCustomfieldBodyItem.fieldJson = customfield.rawJsonValue ?? '';
					}
					customfieldBody.requestFields.push(newCustomfieldBodyItem);
				}
			}
		}

		if (this.newRequest.summary == '') {
			this.newRequest.summary = this.requestTemplate.summary;
		}

		if (this.newRequest.description == '') {
			this.newRequest.description = this.requestTemplate.description;
		}

		if (this.newRequest.affected_location == '') {
			this.newRequest.affected_location = this.enduserData.idLocation;
		}

		this.newRequest.location = this.enduserData.idLocation;

		this.customConfidentialForm.rawValues = this.customConfidentialFormRMK.rawValues;

		this.isOpeningRequest = true;
		this.RequestOpeningService.submitRequest(
			this.newRequest,
			this.options.id_customer,
			this.requestTemplateId,
			this.customConfidentialForm.rawValues,
			customfieldBody
		).subscribe({
			next: (openingRes: any) => {
				if (this.customfields?.length > 0) {
					this.isUploadingCustomfields.push(1);
					this.isUploadingCustomfields.pop();
				}
				if (this.fileCustomfields?.length > 0) {
					for (const fileField of this.fileCustomfields) {
						const fileLog: logInterface = {
							status: 'New',
							notes: `${this.labels.lbl_campo_customizado_anexo} <b>${fileField.name}</b>.`,
							log_date: new ShkDate().getDateTime(),
							idLog: 'NEW',
							duration: '00:00',
							analyst: this.ProfileService.userData().email,
						};
						this.isUploadingCustomfields.push(1);
						this.RequestPageService.addLog(openingRes.id, fileLog).subscribe(
							(logRes: any) => {
								this.RequestPageService.sendAttach(logRes.idLog, fileField.values).subscribe(
									() => {
										this.isUploadingCustomfields.pop();
									},
									() => {
										this.isUploadingCustomfields.pop();
									}
								);
							},
							() => {
								this.isUploadingCustomfields.pop();
							}
						);
					}
				}

				if (this.logFileArray.length > 0) {
					const fileLog: logInterface = {
						status: 'New',
						notes: `<b>${this.labels.lbl_anexo_abertura}</b>`,
						log_date: new ShkDate().getDateTime(),
						idLog: 'NEW',
						duration: '00:00',
						analyst: this.ProfileService.userData().email,
					};
					//isUploadingCustomfields é um array pra indicar carregamento de vários logs simultaneos
					//se existe 2 itens no array, 2 requisições ainda não retornaram resposta
					this.isUploadingCustomfields.push(1);
					this.RequestPageService.addLog(openingRes.id, fileLog).subscribe(
						(logRes: any) => {
							this.RequestPageService.sendAttach(logRes.idLog, this.logFileArray).subscribe(
								() => {
									this.isUploadingCustomfields.pop();
								},
								() => {
									this.isUploadingCustomfields.pop();
									this.NotificationService.setNotificationMessage(this.labels.lbl_erro_envio_arquivos);
								}
							);
						},
						() => {
							this.isUploadingCustomfields.pop();
							this.NotificationService.setNotificationMessage(this.labels.lbl_erro_envio_arquivos);
						}
					);
				}

				this.isOpeningRequest = false;
				this.newRequest.id = openingRes.id;

				this.emitRequestCreated();

				this.RequestPageService.getRequest(this.newRequest.id).subscribe((requestRes) => {
					this.newRequest = requestRes;
				});
			},
			error: (errorRes) => {
				if (errorRes.error.Message === 'Enduser / Customer not found') {
					this.NotificationService.setNotificationMessage(this.labels.lbl_usuario_sem_cadastro_cliente);
				} else {
					this.NotificationService.setNotificationMessage(this.labels.lbl_sem_permissao_abrir_chamado_classificacao);
				}
				this.isOpeningRequest = false;
			},
		});
	}

	setEmptyTemplate(): void {
		this.requestTemplateId = '';
		this.requestTemplate = {
			id: '',
			summary: '',
			status: '',
			description: '',
			informative: '',
			fields: [],
		};
	}

	setEmptyNewRequest(setInitialValues = false): void {
		this.newRequest = {
			id: '',
			summary: '',
			description: '',
			status: '',
			id_enduser: '-1',
			enduser: '',
			emailCC: '',
			parent_request: {
				id: '',
				status: '',
			},
			allowedCiTypes: [],
			mandatoryCiBinding: false,
			relatedCis: [],
			riskType: '',
			affected_location: '',
			location: '',

			inconsistency: { id: '' },
		};
		if (setInitialValues && this.idRelatedInconsistency) this.newRequest.inconsistency.id = this.idRelatedInconsistency;
	}

	emitRequestCreated(): void {
		this.newRequestCreated.emit('true');
	}

	cloneRequest(): void {
		this.newRequest.id = '';
	}

	// Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
	modalClose(event: Event, ignorePropagation: boolean): void {
		if (event.target === document.querySelector('#modalClose')) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
		if (ignorePropagation) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
	}

	openModalEvaluationMSP(): void {
		this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
	}
	// Final Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal

	redirectToKnowSolution(item: any): void {
		window.open(`/knowledgebase/read/${item.id}?idRequest=${this.newRequest.id}`, '_blank');
	}

	changeConfidentialRequest(isConfidential: boolean): void {
		if (this.hasTemplate && this.requestTemplate.confidential_request !== undefined) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_sem_permissao_alterar_campo);
		}
		this.newRequest.confidential = isConfidential ? '1' : '0';
	}

	searchEnduserData(): void {
		this.isLoadingEnduserData = true;
		this.enduserDataReq = this.RequestOpeningService.getEnduserData({
			idEnduser: this.options.id_enduser,
			idCustomer: this.options.id_customer,
		}).subscribe({
			next: (enduserData) => {
				this.enduserData = enduserData;

				this.newRequest.affected_location =
					this.enduserData.idLocation && this.newRequest.affected_location == '' ? this.enduserData.idLocation : '';

				this.newRequest.location = this.enduserData.idLocation;
			},
		});

		this.enduserDataReq.add(() => {
			this.isLoadingEnduserData = false;
		});
	}

	async loadAvailableTemplates() {
		try {
			this.isLoadingAvailableTemplates = true;
			const serviceTypes = ALL_SERVICE_TYPES.filter((serviceType) => !this.options.hide_service_type.includes(serviceType));
			const templates = await this.RequestOpeningService.getAvailableTemplates({ idCust: this.options.id_customer }, serviceTypes);

			for (const template of templates) {
				const newTemplateIAC: iacOptionInterface = {
					name: template.name,
					value: template.id,
				};
				this.availableTemplateIAC.push(newTemplateIAC);
			}
		} catch (error) {
			console.error('Erro ao carregar templates:', error);
		} finally {
			this.isLoadingAvailableTemplates = false;
		}
	}

	addConfidentialUser(id: string): void {
		if (!id) return;

		// Procura o usuário no formulário normal (fonte de verdade dos analistas)
		const existingUser = this.customConfidentialForm.items.find((item) => item.id === id);
		if (!existingUser) return;

		// Cria o usuário genérico com base no existingUser
		const userGeneric: genericFormI = new genericFormI('item');
		userGeneric.id = existingUser.id;
		userGeneric.name = existingUser.name;
		userGeneric.label = existingUser.label;
		userGeneric.values[0] = existingUser.id;
		userGeneric.commonGroup = existingUser.commonGroup;

		// 3. Adicionar o objeto completo do usuário à lista de valores do formulário.
		this.customConfidentialFormRMK.values.push(userGeneric);
		this.customConfidentialFormRMK.rawValues.push(userGeneric.id);

		// 5. Remover o usuário da lista de disponíveis, criando uma nova lista filtrada.
		this.availableConfidentialUsersIAC = this.availableConfidentialUsersIAC.filter((user) => user.value !== id);
	}

	restoreUsersToAvailableList(): void {
		// Verifica se há uma classificação ativa para carregar usuários específicos
		const hasActiveClassification = this.newRequest.id_solution_area || this.newRequest.id_topic;

		if (hasActiveClassification) {
			// Se há classificação, recarrega os usuários do grupo confidencial
			const filters: any = {};
			if (this.newRequest.service_type) filters.idServiceType = this.newRequest.service_type;
			if (this.newRequest.id_scope) filters.idScope = this.newRequest.id_scope;
			if (this.newRequest.id_category) filters.idCategory = this.newRequest.id_category;
			if (this.newRequest.id_topic) filters.idTopic = this.newRequest.id_topic;
			if (this.newRequest.id_solution_area) filters.idSolutionArea = this.newRequest.id_solution_area;

			this.RequestOpeningService.getConfidentialGroupUsersByClassification(filters).subscribe({
				next: (groupUsers) => {
					this.availableConfidentialUsers = [];
					this.availableConfidentialUsersIAC = [];

					if (groupUsers.length > 0) {
						this.availableConfidentialUsers = groupUsers;
						const selectedUserIds = this.customConfidentialFormRMK.rawValues || [];

						for (const user of groupUsers) {
							if (!selectedUserIds.includes(user.id)) {
								this.availableConfidentialUsersIAC.push({
									name: user.fullName,
									value: user.id,
									commonGroup: user.email,
								});
							}
						}
					}
					this.isLoadingAvailableConfidentialAnalysts = false;
				},
				error: () => {
					this.isLoadingAvailableConfidentialAnalysts = false;
				},
			});
		} else {
			// Se não há classificação, carrega todos os usuários confidenciais
			this.RequestOpeningService.getAvailableConfidentialUsers(this.options.id_customer).subscribe({
				next: (availableUsers) => {
					this.availableConfidentialUsers = [];
					this.availableConfidentialUsersIAC = [];
					this.availableConfidentialUsers = availableUsers;

					const selectedUserIds = this.customConfidentialFormRMK.rawValues || [];

					for (const user of availableUsers) {
						if (!selectedUserIds.includes(user.id)) {
							const usersIAC: iacOptionInterface = {
								name: user.fullName,
								value: user.id,
								commonGroup: user.email,
							};
							this.availableConfidentialUsersIAC.push(usersIAC);
						}
					}
					this.isLoadingAvailableConfidentialAnalysts = false;
				},
				error: () => {
					this.isLoadingAvailableConfidentialAnalysts = false;
				},
			});
		}
	}

	loadConfidentialGroupUsers(): void {
		if (!this.newRequest.id_solution_area && !this.newRequest.id_topic) return;
		this.isLoadingAvailableConfidentialAnalysts = true;

		const filters: any = {};
		if (this.newRequest.service_type) filters.idServiceType = this.newRequest.service_type;
		if (this.newRequest.id_scope) filters.idScope = this.newRequest.id_scope;
		if (this.newRequest.id_category) filters.idCategory = this.newRequest.id_category;
		if (this.newRequest.id_topic) filters.idTopic = this.newRequest.id_topic;
		if (this.newRequest.id_solution_area) filters.idSolutionArea = this.newRequest.id_solution_area;

		this.RequestOpeningService.getConfidentialGroupUsersByClassification(filters).subscribe({
			next: (groupUsers) => {
				if (groupUsers.length > 0) {
					this.availableConfidentialUsersIAC = [];
					this.availableConfidentialUsers = [];
					this.newRequest.confidential = '1';

					for (const user of groupUsers) {
						this.availableConfidentialUsers.push(user);
						this.availableConfidentialUsersIAC.push({
							name: user.fullName,
							value: user.id,
							commonGroup: user.email,
						});
					}
				} else {
					// Se não houver groupUsers, carrega os analistas padrão
					this.loadAvailableConfidentialAnalysts();
				}
			},
			error: (error) => {
				console.error('Erro ao carregar usuários do grupo confidencial:', error);
				this.loadAvailableConfidentialAnalysts();
			},
			complete: () => {
				this.isLoadingAvailableConfidentialAnalysts = false;
			},
		});
	}

	loadAvailableConfidentialAnalysts(): void {
		this.customConfidentialForm.name = 'confidentialUsers';
		this.customConfidentialForm.label = 'lbl_quem_podera_visualizar';
		this.RequestOpeningService.getAvailableConfidentialUsers(this.options.id_customer).subscribe({
			next: (availableUsers) => {
				for (const user of availableUsers) {
					const userGeneric: genericFormI = new genericFormI('item');
					userGeneric.id = user.id;
					userGeneric.name = user.fullName;
					userGeneric.label = user.fullName;
					userGeneric.values[0] = user.id;
					this.customConfidentialForm.items.push(userGeneric);
				}

				this.availableConfidentialUsers = [];
				this.availableConfidentialUsersIAC = [];
				this.availableConfidentialUsers = availableUsers;
				for (const user of this.availableConfidentialUsers) {
					const usersIAC: iacOptionInterface = {
						name: user.fullName,
						value: user.id,
						commonGroup: user.email,
					};
					this.availableConfidentialUsersIAC.push(usersIAC);
				}
			},
			complete: () => {
				this.isLoadingAvailableConfidentialUsers = false;
			},
		});
	}
}
